import { Redirect } from 'react-router-dom'
import { useExecutivePermissions } from './permission-store'
import { getExecutiveEntryPath } from './executive-nav.utils'

export default function ExecutiveIndex() {
  const tabs = useExecutivePermissions().executiveDashboardTabs
  return <Redirect to={getExecutiveEntryPath(tabs)} />
}
